@if (hasTerminal()) {
	<div class="content" [class]="getSizeClass()" (window:keydown)="onKeyDown($event)">
		@let activeAlias = activeWorkFlowService.activeAlias;
		@let workFlowType = activeWorkFlowService.workFlowType;
		@if (hasGroups()) {
			<div class="groups" (window:keydown)="preventDefaultKeyBehaviour($event)">
				<table mat-table [dataSource]="dataService.groups">
					@for (column of _groupColumns; track column; let i = $index) {
						<ng-container matColumnDef="{{ column.title }}">
							<th mat-header-cell *matHeaderCellDef [style.width.px]="column.width">
								<span class="resize" (mousedown)="startColumnResize($event, 'group', i)"></span>
								{{ column.title }}
							</th>
							<td mat-cell *matCellDef="let element" [ngClass]="getStyle(column.type)" [style.width.px]="column.width">
								@if (column.source === 'name') {
									{{ element.name }}
								} @else {
									{{ element.items | aggregate: column.source | async | conditionalFormat: column.type : column.format : 'da-DK' }}
								}
							</td>
						</ng-container>
					}
					<ng-container matColumnDef="operations">
						<th mat-header-cell *matHeaderCellDef></th>
						<td mat-cell *matCellDef="let element">
							@if (workFlowType === 'Group') {
								<div class="right-buttons">
									<!-- When group flow, you should only be able to set a group active that has completeable items and that isnt active already -->
									@if (activeAlias !== element.name) {
										<button mat-flat-button color="primary" class="operation-button" (click)="onStartGroup($event, element)" [disabled]="!canStartGroup(element) || element.name === 'DEFAULT'">
											<mat-icon svgIcon="acies_mes_start"></mat-icon>
										</button>
									}
									<!-- When group flow, you should only be able to remove active on the group that is active -->
									@if (activeAlias === element.name) {
										<button mat-flat-button color="primary" class="operation-button" (click)="removeActive()" [disabled]="!anyApproveable(element) || isPending('group|' + element.name)">
											<mat-icon svgIcon="acies_mes_pause"></mat-icon>
										</button>
									}
									<!-- When group flow, you should only be able to complete the group that is active and has completeable items -->
									<button mat-flat-button color="primary" class="operation-button" (click)="onGroupApprove($event, element)" [disabled]="!anyApproveable(element) || isPending('group|' + element.name) || activeAlias !== element.name || element.name === 'DEFAULT'">
										<mat-icon svgIcon="acies_mes_complete_all"></mat-icon>
									</button>
								</div>
							}
						</td>
					</ng-container>
					<tr mat-header-row *matHeaderRowDef="getGroupColumnNames(); sticky: true"></tr>
					<tr mat-row *matRowDef="let row; columns: getGroupColumnNames()" (mousedown)="onGroupRowClick(row)" [ngClass]="getGroupClass(row)"></tr>
				</table>
			</div>
		}
		<ng-template #ItemsTemplate>
			@if (hasItems()) {
				<div class="items" (window:keydown)="preventDefaultKeyBehaviour($event)">
					<table id="items-header">
						<thead class="table-header items-header-table">
							@for (column of _itemColumns; track column; let i = $index) {
								<th class="material-header" [style.width.px]="column.width">
									<span class="resize" (mousedown)="startColumnResize($event, 'item', i)"></span>
									{{ column.title }}
								</th>
							}
							<th #actionHeader class="material-header" [ngClass]="workFlowType === 'Item' ? 'operations-header-item-flow' : 'operations-header-group-flow'"></th>
						</thead>
					</table>
					<cdk-virtual-scroll-viewport #itemViewport itemSize="50" class="virtual-scroll-viewport">
						<table id="items-content">
							<colgroup>
								@for (w of colWidths; track w) {
									<col [style.width.px]="w" />
								}
							</colgroup>
							<tbody>
								<tr *cdkVirtualFor="let element of dataService.currentGroup.items" class="material-row" [ngClass]="getItemClass(element)" (click)="onItemRowClick(element)">
									@for (column of _itemColumns; track column) {
										<td class="material-cell" [style.width.px]="column.width" [ngClass]="getStyle(column.type)">
											@if (returnParsedItem(element); as parsedItem) {
												{{ parsedItem[column.source] | conditionalFormat: column.type : column.format : 'da-DK' }}
											}
										</td>
									}
									<td class="material-cell">
										<div class="right-buttons">
											<!-- When item flow, you should only be able to set an item active that isnt already active and that has completeable items -->
											@if (workFlowType === 'Item' && !isActiveItemRow(element)) {
												<button mat-flat-button color="primary" class="operation-button" (click)="onStartItem($event, element)" [disabled]="!canStartItem(element)">
													<mat-icon svgIcon="acies_mes_start"></mat-icon>
												</button>
											}
											<!-- When item flow, you should only be able to remove active on the active item -->
											@if (workFlowType === 'Item' && isActiveItemRow(element)) {
												<button mat-flat-button color="primary" class="operation-button" (click)="removeActive()" [disabled]="!approveable(element) || isPending('item|' + element.alias)">
													<mat-icon svgIcon="acies_mes_pause"></mat-icon>
												</button>
											}
											<!-- When item flow, you should only be able to complete the item that is active -->
											<button mat-flat-button color="primary" class="operation-button" (click)="onApprove($event, element)" [disabled]="!approveable(element) || isPending('item|' + element.alias) || (workFlowType === 'Item' && !isActiveItemRow(element))">
												@if (!isPending('item|' + element.alias)) {
													<mat-icon svgIcon="acies_mes_complete"></mat-icon>
												} @else {
													<img alt="" matButtonIcon src="./assets/spinner2.gif" class="gifIcon" />
												}
											</button>
											<!-- When item flow, you should only be able to uncomplete items that have been completed -->
											<button mat-flat-button color="primary" class="operation-button" (click)="onUnapprove($event, element)" [disabled]="!unapproveable(element) || isPending('item|' + element.alias)">
												<mat-icon svgIcon="acies_mes_uncomplete"></mat-icon>
											</button>
											<!-- When item flow, you should only be able to reorder items that are ready, and never on the first terminals -->
											<button mat-flat-button color="primary" class="operation-button" (click)="onReorder($event, element)" [disabled]="!reorderable(element) || isPending('item|' + element.alias) || isFirstTerminal">
												<mat-icon svgIcon="acies_mes_reorder"></mat-icon>
											</button>
											<!-- When item flow, you should always be able to open the stock reorder dialogue (also contains production note) -->
											<button mat-flat-button color="primary" class="operation-button" [class.has-notes]="itemHasNotes(element.alias) | async" (click)="onStockReorder($event, element)" [disabled]="isPending('item|' + element.alias)">
												<mat-icon svgIcon="acies_mes_add_stockreorder"></mat-icon>
											</button>
										</div>
									</td>
								</tr>
							</tbody>
						</table>
					</cdk-virtual-scroll-viewport>
				</div>
			}
		</ng-template>
		@if (hasGroups()) {
			<ng-container *ngTemplateOutlet="ItemsTemplate"></ng-container>
		} @else {
			<app-slide-panel [stateStorageName]="productionTerminalService.terminalId" #asp>
				<ng-container *ngTemplateOutlet="ItemsTemplate"></ng-container>
			</app-slide-panel>
		}
		@if (hasDetails()) {
			<app-production-data-view-detail #details [html]="getDetailHtml()" [data]="getDetailData()" class="details" [class.left-margin]="hasDetails()"></app-production-data-view-detail>
		}
	</div>
}

@if (dataService.loadingData) {
	<div class="overlay">
		<mat-spinner></mat-spinner>
	</div>
} @else if (!hasItems()) {
	<div class="overlay-no-terminal-data">
		<p class="header">{{ 'mes.mes-production-terminal.no-terminal-data' | translate }}</p>
	</div>
}
